import { __extends } from "tslib";
import { Loader as AwayLoader } from "@awayjs/core";
import { Bitmap } from "./Bitmap";
import { DisplayObjectContainer } from "./DisplayObjectContainer";
import { LoaderEvent, AssetEvent, WaveAudio } from "@awayjs/core";
import { MovieClip as AwayMovieClip, Sprite as AwaySprite, TextField as AwayTextField } from "@awayjs/scene";
import { Event } from "../events/Event";
import { ProgressEvent } from "../events/ProgressEvent";
import { Font, SceneImage2D } from "@awayjs/scene";
import { Image2DParser, BitmapImage2D } from "@awayjs/stage";
import { FlashSceneGraphFactory } from "../factories/FlashSceneGraphFactory";
import { URLLoaderEvent } from "@awayjs/core";
import { release, somewhatImplemented } from '@awayfl/swf-loader';
import { UncaughtErrorEvents } from '../events/UncaughtErrorEvents';
import { Errors } from '@awayfl/avm2';
import { Graphics } from '@awayjs/graphics';
// todo: define all methods (start new with converting as3-Loader to ts ?)
var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader(parser) {
        var _this = _super.call(this) || this;
        _this._onLoaderProgressDelegate = function (event) { return _this.onLoaderProgress(event); };
        _this._onLoaderCompleteDelegate = function (event) { return _this.onLoaderComplete(event); };
        _this._onAssetCompleteDelegate = function (event) { return _this.onAssetComplete(event); };
        _this._parser = parser;
        _this._loaderInfo = new _this.sec.flash.display.LoaderInfo();
        _this._loaderInfo._loader = _this;
        _this._factory = new FlashSceneGraphFactory(null);
        return _this;
    }
    Object.defineProperty(Loader.prototype, "content", {
        // for AVM1:
        get: function () {
            return this._content;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Loader.prototype, "uncaughtErrorEvents", {
        get: function () {
            release || somewhatImplemented("public flash.display.Loader::uncaughtErrorEvents");
            if (!this._uncaughtErrorEvents) {
                this._uncaughtErrorEvents = new UncaughtErrorEvents();
            }
            return this._uncaughtErrorEvents;
        },
        enumerable: true,
        configurable: true
    });
    Loader.prototype.onLoaderProgress = function (event) {
        var newEvent = new ProgressEvent(ProgressEvent.PROGRESS, null, null, event.urlLoader.bytesLoaded, event.urlLoader.bytesTotal);
        newEvent.currentTarget = this._loaderInfo;
        this._loaderInfo.dispatchEventInternal(newEvent);
    };
    Loader.prototype.onLoaderComplete = function (event) {
        var newEvent = new Event(Event.COMPLETE);
        newEvent.currentTarget = this._loaderInfo;
        this._loaderInfo.dispatchEventInternal(newEvent);
        this._loader.removeEventListener(LoaderEvent.LOAD_COMPLETE, this._onLoaderCompleteDelegate);
        this._loader.removeEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        this._loader = null;
        //AssetLibrary.removeEventListener(LoaderEvent.LOAD_COMPLETE, this._onLoaderCompleteDelegate);
        //AssetLibrary.removeEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
    };
    Loader.prototype.onAssetComplete = function (event) {
        // 	todo: take care of all needed asset-types (sounds / fonts / textfield)
        //	todo: update awd to support as3-class-identifier as extra property. 
        //  atm the name of the exported symbols will be the as3-class name, 
        //  and all exported symbols are handled as if exposed to as3
        var asset = event.asset;
        if (asset.isAsset(AwayTextField)) {
            this._loaderContext.applicationDomain.addDefinition(asset.name, asset);
        }
        else if (asset.isAsset(SceneImage2D) || asset.isAsset(BitmapImage2D)) {
            this._loaderContext.applicationDomain.addDefinition(asset.name, asset);
            // we should only do this for bitmaps loaded from jpg or png
            if (this._isImage)
                this._adaptee.addChild(new Bitmap(asset.adapter).adaptee);
            //this.addChild(this._loaderInfo.content = new Bitmap(<BitmapData> (<SceneImage2D> asset).adapter));
        }
        else if (asset.isAsset(WaveAudio)) {
            this._loaderContext.applicationDomain.addAudioDefinition(asset.name, asset);
        }
        else if (asset.isAsset(Font)) {
            this._loaderContext.applicationDomain.addFontDefinition(asset.name, asset);
        }
        else if (asset.isAsset(AwaySprite)) {
            //if((<AwaySprite> asset).material)
            //	(<AwaySprite> asset).material.bothSides=false;
            this._loaderContext.applicationDomain.addDefinition(asset.name, asset);
        }
        else if (asset.isAsset(AwayMovieClip)) {
            this._loaderContext.applicationDomain.addDefinition(asset.name, asset);
            // if this is the "Scene 1", we make it a child of the loader
            if (asset.name == "Scene 1" || asset.isAVMScene) { // "Scene 1" when AWDParser, isAVMScene when using SWFParser
                var newClone = asset.adapter.clone();
                newClone.loaderInfo = this.loaderInfo;
                newClone.adaptee.reset();
                this.addChild(newClone);
                //this.addChild(this._loaderInfo.content = (<MovieClip>(<AwayMovieClip>asset).adapter));
            }
        }
        else if (asset.isAsset(Graphics)) {
        }
        else {
            console.log("loaded unhandled asset-type");
        }
    };
    Loader.prototype.addChild = function (child) {
        return _super.prototype.addChild.call(this, child);
    };
    Loader.prototype.addChildAt = function (child, index) {
        this.sec.throwError('IllegalOperationError', Errors.InvalidLoaderMethodError);
        return null;
    };
    Loader.prototype.removeChild = function (child) {
        this.sec.throwError('IllegalOperationError', Errors.InvalidLoaderMethodError);
        return null;
    };
    Loader.prototype.removeChildAt = function (index) {
        this.sec.throwError('IllegalOperationError', Errors.InvalidLoaderMethodError);
        return null;
    };
    Loader.prototype.setChildIndex = function (child, index) {
        this.sec.throwError('IllegalOperationError', Errors.InvalidLoaderMethodError);
    };
    Loader.prototype.load = function (url, context) {
        if (context === void 0) { context = null; }
        console.log("start loading the url:" + url.url);
        var ext = url.url.substr(-3);
        this._isImage = (ext == "jpg" || ext == "png");
        //url.url=url.url.replace(".swf", ".awd");
        this._loaderContext = context;
        this._loaderInfo.applicationDomain = context.applicationDomain;
        this._loader = new AwayLoader();
        this._loader.addEventListener(URLLoaderEvent.LOAD_PROGRESS, this._onLoaderProgressDelegate);
        this._loader.addEventListener(LoaderEvent.LOAD_COMPLETE, this._onLoaderCompleteDelegate);
        this._loader.addEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        this._loader.load(url.adaptee, null, null, (this._isImage) ? new Image2DParser(this._factory) : this._parser);
    };
    Loader.prototype.loadData = function (buffer, context) {
        if (context === void 0) { context = null; }
        console.log("start loading swfdata", buffer);
        this._loaderContext = context;
        this._loaderInfo.applicationDomain = context.applicationDomain;
        this._loader = new AwayLoader();
        this._loader.addEventListener(URLLoaderEvent.LOAD_PROGRESS, this._onLoaderProgressDelegate);
        this._loader.addEventListener(LoaderEvent.LOAD_COMPLETE, this._onLoaderCompleteDelegate);
        this._loader.addEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        this._loader.loadData(buffer, null, null, null, this._parser);
    };
    Loader.prototype.loadBytes = function (data, context) {
        this.close();
        console.log("80pro todo: loader.loadBytes");
        /*
        // TODO: properly coerce object arguments to their types.
        var loaderClass = Loader.axClass;
        // In case this is the initial root loader, we won't have a loaderInfo object. That should
        // only happen in the inspector when a file is loaded from a Blob, though.
        this._contentLoaderInfo._url = (this.loaderInfo ? this.loaderInfo._url : '') +
                                        '/[[DYNAMIC]]/' + (++loaderClass._embeddedContentLoadCount);
        this._applyLoaderContext(context);
        this._loadingType = LoadingType.Bytes;
        this._fileLoader = new FileLoader(this, this._contentLoaderInfo);
        this._queuedLoadUpdate = null;
        if (!release && traceLoaderOption.value) {
            console.log("Loading embedded symbol " + this._contentLoaderInfo._url);
        }
        // Just passing in the bytes won't do, because the buffer can contain slop at the end.
        this._fileLoader.loadBytes(new Uint8Array((<any>data).bytes, 0, data.length));

        release || assert(loaderClass._loadQueue.indexOf(this) === -1);
        loaderClass._loadQueue.push(this);
        */
    };
    Loader.prototype.close = function () {
        console.log("80pro todo: loader.close");
        // var queueIndex = Loader.axClass._loadQueue.indexOf(this);
        // if (queueIndex > -1) {
        //   Loader.axClass._loadQueue.splice(queueIndex, 1);
        // }
        // this._contentLoaderInfo.reset();
        // if (!this._fileLoader) {
        //   return;
        // }
        // this._fileLoader.abortLoad();
        // this._fileLoader = null;
    };
    Loader.prototype._unload = function (stopExecution, gc) {
        console.log("80pro todo: loader._unload");
        // if (this._loadStatus < LoadStatus.Initialized) {
        //   this._loadStatus = LoadStatus.Unloaded;
        //   return;
        // }
        // this.close();
        // this._content = null;
        // this._contentLoaderInfo._loader = null;
        // this._loadStatus = LoadStatus.Unloaded;
        // this.dispatchEvent(Event.axClass.getInstance(Event.UNLOAD));
    };
    Loader.prototype.unload = function () {
        this._unload(false, false);
    };
    Loader.prototype.unloadAndStop = function (gc) {
        // TODO: remove all DisplayObjects originating from the unloaded SWF from all lists and stop
        // them.
        this._unload(true, !!gc);
    };
    Object.defineProperty(Loader.prototype, "contentLoaderInfo", {
        get: function () {
            return this._loaderInfo;
        },
        set: function (value) {
            this._loaderInfo = value;
        },
        enumerable: true,
        configurable: true
    });
    return Loader;
}(DisplayObjectContainer));
export { Loader };
